<template>
<div style="background-color:white;" class="container">


  
<!-- position:fixed; -->
  <nav class="navbar" role="navigation" aria-label="main navigation" style=" z-index:998; ">
        <div class="navbar-brand">

          <router-link tag="a" class="navbar-item" to="/servicios">
          <button class="button is-link is-outlined">
            See all Exodus tours</button>
          </router-link>

          <!-- <button @click="cerrarModalBusqueda" class="button is-info">Cerrar</button> -->

          <a @click="menuMobile" role="button" :class="(showMenuMobile)?'navbar-burger burger is-active':'navbar-burger burger'" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample" style=" z-index:999; ">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>

        <div id="navbarBasicExample" @click="menuMobile" :class="(showMenuMobile)?'navbar-menu is-active':'navbar-menu'">
          <div class="navbar-start">

            <router-link tag="a" class="navbar-item" to="/servicios">
              Services
            </router-link>

            <!-- <a class="navbar-item">
              Test
            </a> -->

            <a class="navbar-item">
              Contact
            </a>

          </div>

          <div class="navbar-end">
            <div class="navbar-item">
              <div class="buttons">
                <a target="_blank" class="button is-primary">
                  <strong>Register</strong>
                </a>
                <a href="http://booking.sistemy.mx" target="_blank" class="button is-light">
                  Login
                </a>
              </div>
            </div>

            
          </div>
        </div>

      </nav>

  <!-- {{total}} -->
  <div class="columns">
    <!-- <div class="column is-10"> -->
    <div class="column">
      <router-view></router-view>
      <component :is="menuComponente" v-if="$route.path=='/'" ></component>
    </div>
  </div>

  <div id="modalBusqueda" class="modal" align="center">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <span class="modal-card-title">
          <strong>Búsqueda en fecha {{this.buscaReservaFecha}}</strong>
        </span>
        <button class="delete" @click="cerrarModalBusqueda" aria-label="close"></button>
      </header>
      <section class="modal-card-body" align="left">
        
        <template v-for="reserva in reservacionesList" >
          <span v-text="reserva.cliente"> </span><br>
        </template>


      </section>
      <footer class="modal-card-foot">
        <button @click="cerrarModalBusqueda" class="button is-info">Cerrar</button>
      </footer>
    </div>
  </div>

  <footer class="footer">
      <div class="content has-text-centered">
        <p>
          <strong>Exodus tickets</strong> by <a href="http://sistemy.mx">Sistemy</a>. 
          <a href="">See our privacy advice</a>. 
          
          Contact us at reservations@sistemy.mx
        </p>
      </div>
    </footer>


</div>
</template>

<script>

import axios from 'axios'
import Cors from 'cors'
import moment from 'moment'

import { EventBus } from './bus.js';
import qs from 'qs'

import Servicios from './exodus/servicios.vue'
import Reservar from './empleados/reservar.vue'
import Pickups from './empleados/pickups.vue'
import PickupsReporte from './empleados/pickups_reporte.vue'
import Regresos from './empleados/regresos.vue'
import RegresosReporte from './empleados/regresos_reporte.vue'
import NoShow from './empleados/no_show.vue'
import Cancelados from './empleados/cancelados.vue'
import Gps from './empleados/gps.vue'

import Cloud from './sistemy/cloud.vue'



export default {

  components: {
    'app-servicios': Servicios,
    'app-reservar': Reservar,
    'app-pickups' : Pickups,
    'app-pickups_reporte' : PickupsReporte,
    'app-regresos' : Regresos,
    'app-regresos_reporte' : RegresosReporte,
    'app-no_show' : NoShow,
    'app-cancelados' : Cancelados,
    'app-gps' : Gps,

    'app-cloud' : Cloud
  },
  data () {
    return {
      menuComponente: 'app-servicios',
      mail: '',
      pass: '',
      option: '0',
      alturaVentana: window.innerHeight - 100,
      anchoVentana: window.innerWidth - 20,
      validadorClick: 0,
      total: 0,
      buscaReservaFecha: moment().format('DD-MM-YYYY'),
      buscaReserva:'',
      reservacionesList:'',
      showMenuMobile:false,
      host: 'booking.vws.com.mx'

    }
  },
  computed: {

  },

  created () {
    var estancia = this;
    console.log("test jp",this.$route.path)
    console.log(this.$route.params,'params')
    if(this.$route.path=='/'){
      this.router.push('/servicios')
    }
    console.log(this.$cookies.get('RhSession'),'sesion info')


    EventBus.$on('cambioCompon',(datoInt, datoString) => {

      estancia.changeCompon(datoString);
      estancia.validadorClick = datoInt ;

    })

    document.addEventListener('DOMContentLoaded', function () {
      // Dropdowns
      var $dropdowns = getAll('.dropdown:not(.is-hoverable)')

      if ($dropdowns.length > 0) {
        $dropdowns.forEach(function ($el) {
          $el.addEventListener('click', function (event) {
            event.stopPropagation()
            $el.classList.toggle('is-active')
          })
        })

        document.addEventListener('click', function (event) {
          closeDropdowns()
        })
      }

      function closeDropdowns () {
        $dropdowns.forEach(function ($el) {
          $el.classList.remove('is-active')
        })
      }

      // Close dropdowns if ESC pressed
      document.addEventListener('keydown', function (event) {
        var e = event || window.event
        if (e.keyCode === 27) {
          closeDropdowns()
        }
      })

      // Functions

      function getAll (selector) {
        return Array.prototype.slice.call(document.querySelectorAll(selector), 0)
      }

    })
  },
  methods: {
    menuMobile () {
      this.showMenuMobile=!this.showMenuMobile
    },
    buscarReservacion () {
        // axios.post('http://localhost:3000/justRead',{
        //   select: 'id, nombre',
        //   table: 'monedas',
        //   where: '',
        //   condition: ''
        // })
        var select = `*`;
        var tabla = "reservaciones";
        var where = " fecha = '"+this.buscaReservaFecha+"' and cliente like '%"+this.buscaReserva+"%' ";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then((response)=>{
          if (response.status == 200 ) {
            this.reservacionesList = response.data;
            console.log(response,'response');
            $("#modalBusqueda").addClass("is-active");
          }else{
            console.log('error');
          }
        });
    },
    cerrarModalBusqueda:function(){
      $("#modalBusqueda").removeClass("is-active");
      this.reservacionesList=''
      this.buscaReserva=''
    },
    hoy () {
      return moment().format('DD-MM-YYYY')
    },
    cerrarSesion: function () {
      this.$cookies.remove('RhSession')
      location.reload()
    },
    current: function (selected) {
      this.option = selected
    },
    changeCompon: function (data) {
      console.log('cambiamos el componente')
      console.log(data)
      this.menuComponente = data
    }
  }
}
</script>